<template>
  <div class="container">
    <BLoading :active.sync="isLoading" />

    <header>
      <LsSupportHeader :label="t('rejectService')" test-id="long_grass_rejected_service-title" />
    </header>

    <LsInput
      v-model="reason"
      track-id="long_grass_rejected_service-reject_reason"
      test-id="long_grass_rejected_service-reject_reason"
      :label="t('whyRejectService')"
      :sub-label="t('longGrass.longGrassCleanupRequired')"
      :placeholder="t('provideMoreDetailsToSupport')"
      name="reject_reason"
      type="textarea"
    />

    <LsButton
      :text="t('submit')"
      track-id="long_grass_rejected_service-submit_reject"
      test-id="long_grass_rejected_service-submit_reject"
      bg-color="primary"
      text-color="white"
      class="submitReject"
      @click="submitReject"
    />
  </div>
</template>

<script>
import LsSupportHeader from '@/views/Authorized/SupportView/components/LsSupportHeader/LsSupportHeader.vue';
import LsInput from '@/components/common/LsInput/LsInput.vue';
import LsButton from '@/components/common/LsButton/LsButton.vue';
import { mapActions, mapState } from 'vuex';
import { SUPPORT__SUBMIT_MESSAGE } from '@/store/modules/support/types';
import { themedComponentMixin } from '@/mixins';
import { lsStorageService, lsToastService } from 'ls-vue-common';

export default {
  name: 'LongGrassRejectedServiceView',
  components: { LsButton, LsInput, LsSupportHeader },
  mixins: [themedComponentMixin],
  data() {
    return {
      reason: '',
    };
  },
  computed: {
    ...mapState(['support']),
    isLoading() {
      return this.support.loadingStatus.isUpdating;
    },
    quoteHash() {
      const { property_id, schedule_id, scheduleevent_id, report_id } = this.$route.params;
      return [property_id, schedule_id, scheduleevent_id, report_id].join('');
    },
  },
  methods: {
    ...mapActions([SUPPORT__SUBMIT_MESSAGE]),
    async submitReject() {
      await this[SUPPORT__SUBMIT_MESSAGE]({
        topic: 'Long Grass Quote',
        issue: 'Reject Fee',
        message: this.reason,
        noSideEffects: true,
        onSuccess: this.onSuccess,
      });
    },
    onSuccess() {
      const { t, brandName } = this;
      lsToastService.open({
        message: t('supportAgentWillReachYou', { brandName }),
      });

      lsStorageService.set(this.quoteHash, true);
      this.$router.push({ name: 'services' });
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  padding-bottom: 3rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid $theme-color-primary-light;
}
.submitReject {
  margin-top: 3rem;
}
</style>
